import LayoutChat from '~componentes/LayoutChat.vue';
import Chat from './Chat.vue';
import storage from '~js/storage';
import tipoUsuario from '~js/tipo-usuario';

export default {
  path: '/chat',
  component: LayoutChat,
  meta: { auth: true },
  beforeEnter: (to, from, next) => {
    var usuario = storage.usuario()

    if (usuario == undefined)
      return { path: from.path }

    if (usuario == null)
      return { path: from.path }

    if (usuario.tipoUsuario != tipoUsuario.UsuarioChat)
      return { path: from.path }

    next()
  },
  children: [
    {
      path: '',
      component: Chat,
      name: 'chat',
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/chat/rotas.js